<div *ngIf="isInModal" class="{{ !isNullValue ? 'text-success' : 'text-dark' }} font-size- fw-bold ">
  {{ placeHolder | translate }}
</div>
<tristate-switch
  [formControl]="formControl"
  [placeholder]="!isInModal ? placeHolder : null"
  [ngClass]="{ 'd-inline-block': isInModal }"
></tristate-switch>
<hr *ngIf="isInModal" />
